(() => {
  const setup = (scope = document) => {
    scope.querySelectorAll('[data-merch-shop]:not([data-merch-bound])').forEach(shop => {
      shop.dataset.merchBound = 'true';
      const filters = shop.querySelector('.merch-filters');
      const grid = shop.querySelector('.product-grid');
      if (!filters || !grid || !shop.hasAttribute('data-merch-filterable') || !shop.querySelector('.runway-piece--apparel')) return;
      filters.hidden = false;
      filters.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
        const value = button.dataset.merchFilter;
        filters.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        grid.classList.toggle('is-filtered', value !== 'all');
        let count = 0;
        grid.querySelectorAll('.runway-piece').forEach(card => {
          const apparel = card.classList.contains('runway-piece--apparel');
          card.hidden = value !== 'all' && (value === 'apparel' ? !apparel : apparel);
          if (!card.hidden) count++;
        });
        shop.querySelector('[data-merch-count]').textContent = count;
      }));
    });
    scope.querySelectorAll('[data-merch-product]:not([data-merch-bound])').forEach(root => {
      root.dataset.merchBound = 'true';
      const form = root.querySelector('form');
      const select = root.querySelector('[data-variant-select]');
      const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
      const add = root.querySelector('[data-add]');
      const gallery = root.querySelector('.product-gallery');
      const views = root.querySelector('.merch-views');
      const sticky = root.querySelector('.merch-sticky-buy');
      const stickyAdd = root.querySelector('[data-sticky-add]');
      let lastMedia = null;
      const resetView = () => {
        gallery.style.removeProperty('--detail-scale');
        gallery.style.removeProperty('--detail-origin');
        views?.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.detailView === 'full')));
      };
      if (views && gallery.querySelector('img')) {
        views.hidden = false;
        views.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
          const view = button.dataset.detailView;
          views.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
          const hoodie = root.dataset.detailType === 'hoodie';
          gallery.style.setProperty('--detail-scale', view === 'full' ? '1' : view === 'neck' ? '2.05' : '2.6');
          gallery.style.setProperty('--detail-origin', view === 'full' ? '50% 50%' : view === 'neck' ? (hoodie ? '50% 17%' : '50% 15%') : (hoodie ? '57% 43%' : '56% 32%'));
        }));
      }
      const sync = () => {
        const variant = variants.find(v => String(v.id) === select.value);
        const id = variant?.featured_media?.id;
        if (id && id !== lastMedia) {
          const slide = [...root.querySelectorAll('[data-media-id]')].find(el => el.dataset.mediaId === String(id));
          if (slide) {
            root.querySelectorAll('[data-gallery-slide]').forEach(el => el.classList.toggle('is-active', el === slide));
            root.querySelectorAll('[data-gallery-target]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.galleryTarget === slide.dataset.gallerySlide)));
            resetView();
            lastMedia = id;
          }
        }
        root.querySelector('[data-sticky-price]').textContent = root.querySelector('[data-price]').textContent;
        root.querySelector('[data-sticky-selection]').textContent = variants.length > 1 ? variant?.title || '' : '';
        stickyAdd.disabled = add.disabled;
        stickyAdd.textContent = add.textContent.trim();
      };
      root.addEventListener('change', () => requestAnimationFrame(sync));
      root.querySelectorAll('[data-gallery-target]').forEach(button => button.addEventListener('click', resetView));
      sync();
      stickyAdd.addEventListener('click', () => { if (!add.disabled) form.requestSubmit(add); });
      // A direct scroll jump can skip the intersection state entirely.
      // Check the actual position once per animation frame, including resize.
      let stickyFrame = 0;
      const updateSticky = () => {
        if (stickyFrame) return;
        stickyFrame = requestAnimationFrame(() => {
          stickyFrame = 0;
          if (!root.isConnected) {
            window.removeEventListener('scroll', updateSticky);
            window.removeEventListener('resize', updateSticky);
            return;
          }
          sticky.hidden = innerWidth > 700 || add.getBoundingClientRect().bottom >= 0;
        });
      };
      window.addEventListener('scroll', updateSticky, {passive: true});
      window.addEventListener('resize', updateSticky);
      updateSticky();
      const dialog = root.querySelector('.merch-size-dialog');
      if (dialog) {
        let opener;
        root.querySelectorAll('[data-size-guide]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => { opener = button; dialog.showModal(); });
        });
        dialog.querySelector('[data-close-size]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => opener?.focus());
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        });
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
